// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightSquareFilledSvg from "@fishx/icons-svg/es/asn/RightSquareFilled";
import FishxIcon from '../components/FishxIcon';

var RightSquareFilled = function RightSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareFilledSvg
  }));
};

RightSquareFilled.displayName = 'RightSquareFilled';
export default React.forwardRef(RightSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RightSquareFilled.js
// module id = 4017
// module chunks = 0